export class LookupModel {

  public id: number;

  public name: string;
  public altName: string;
  public selected: boolean;
}

